import React from "react";
import * as palette from "@govlaunch/palette";
import { default as Link } from "next/link";
import upperFirst from "lodash/fp/upperFirst";
import * as Types from "~/types/types";
import { FormattedMessage } from "react-intl";

interface ICurrentBillingPaymentMethodProps {
  billing: { __typename: "Billing" } & {
    card: Types.Maybe<
      { __typename: "CardSource" } & Pick<
        Types.ICardSource,
        "brand" | "lastFourDigits" | "expirationMonth" | "expirationYear"
      >
    >;
  };
}

export default function CurrentBillingPaymentMethod({ billing }: ICurrentBillingPaymentMethodProps) {
  return (
    <>
      <div
        css={{
          fontSize: 16,
          fontWeight: 600,
          color: "#949195",
        }}
      >
        <FormattedMessage defaultMessage="Payment Method" id="nFQbxh" />
      </div>

      <div
        css={{
          display: "grid",
          gridRowGap: 10,
        }}
      >
        {billing && billing.card ? (
          <div>
            <strong
              css={{
                fontSize: 16,
                fontWeight: 600,
                color: palette.text,
              }}
            >
              <FormattedMessage
                defaultMessage="{cardBrand} **** {lastFourDigits}" id="sPwgku"
                values={{
                  cardBrand: upperFirst(billing.card.brand),
                  lastFourDigits: billing.card.lastFourDigits,
                }}
              />
            </strong>
          </div>
        ) : (
          <span
            css={{
              fontSize: 16,
              fontWeight: 600,
              color: palette.text,
            }}
          >
            N/A
          </span>
        )}

        <div>
          <Link href="/billing/payment" passHref={true}>
            <a
              href="/billing/payment"
              css={{
                color: "#005aee",
                fontSize: 13,
              }}
            >
              <FormattedMessage defaultMessage="Add a new card" id="lrfCD6" />
            </a>
          </Link>
        </div>
      </div>
    </>
  );
}
